import { useEffect, useState } from "react"
import { SortingItem } from "../../../utils/api-objects/SortingItem"
import { getAllSortingItemsApi } from "../../../utils/apis/order-service"
import { useAuth } from "../../../utils/context/AuthContext"

export const useGetAllSortingItems = () => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [sortingItems, setSortingItems] = useState<SortingItem[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (!idToken) return

        setIsLoading(true)
        getAllSortingItemsApi(
            idToken,
            (items) => {
                setSortingItems(items)
                setIsLoading(false)
            },
            (err) => {
                console.error("Failed to fetch sorting items:", err)
                setError("Impossibile caricare gli acquisti")
                setIsLoading(false)
            }
        )
    }, [idToken])

    return { sortingItems, isLoading, error }
}